<template>
	<div class="animal-count">
		<div class="animal-count__datawrapper">
			<div class="img-wrapper">
				<img :src="img" v-if="img"/>
			</div>
	
			<label :for="name">
				{{ title }}
			</label>
		</div>

		<div :class="focussed ? 'animal-counter__controls' : ''">
			<template v-if="focussed">
				<button type="button" @click="add(-1)" class="button subtract" :disabled="actualValue <= 0">
					<svg width="12" height="2" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M11.4 1H.6" stroke="#FFF" stroke-width="1.08" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
				</button>
				<input
						ref="input"
						type="number"
						:name="name"
						v-model.lazy.number="actualValue"
						step="1"
						min="0"
						max="100"
	
						:id="name"
				/>
				<button type="button" @click="add(1)" class="button add">
					<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6 .6v10.8M11.4 6H.6" stroke="#FFF" stroke-width="1.08" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
				</button>
			</template>
	
			<template v-else>
				<template v-if="actualValue">
					<button type="button" @click="focus" class="button indicator">
						<span>{{actualValue}}</span>
					</button>
				</template>
				<template v-else>
					<button type="button" @click="focus" class="button add">
						<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6 .6v10.8M11.4 6H.6" stroke="#FFF" stroke-width="1.08" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
					</button>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: "AnimalCount",
	props: {
		title: {},
		name: {},
		modelValue: {
			default: 0,
		},
		img: {},
		focussed: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			actualValue: 0,
		}
	},
	created() {
		this.actualValue = this.modelValue;
	},
	methods: {
		add(val){
			this.actualValue = Math.max(0, (parseInt(this.actualValue) || 0) + val);
		},
		focus(){
			this.$emit('grabFocus');
			if (this.actualValue == 0) {
				this.add(1);
			}
		},
		blur(){
			console.log('blur!');
			this.$emit('blur');
		},
	},
	watch: {
		actualValue(val){
			this.$emit('update:modelValue', val);
		},
		// focussed(val){
		// 	setTimeout(() => {
		// 		if(val){
		// 			this.$refs.input.focus();
		// 		}
		// 	},0);
		// },
	},

}
</script>

<style scoped>
.animal-count {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #d8dbde;
	min-height: 96px;
}

.animal-count__datawrapper {
	display: flex;
	align-items: center;
}

.img-wrapper {
	padding: 0 8px;
	height: 72px;
	width: 72px;
	margin: 12px 0;
	border-radius: 7px;
	border: solid 1px #dadde2;
	background: white;
	overflow: hidden;
}

.img-wrapper img {
	object-fit: contain;
	height: 100%;
	width: 100%;
}

label {
	margin: 0;
	font-size: 1.4rem;
	font-weight: normal;
	margin-left: 18px;
}

.button {
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 9px;
	border: 0;
	touch-action: manipulation;
}

.animal-counter__controls {
	display: flex;
	align-items: center;
	padding-left: 20px;
	box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.1);
	background-color: #fff;
	align-self: stretch;
}

.indicator {
	font-size: 16px;
	font-weight: bold;
	color: white;
	background-color: #da503b;
}

.indicator span {
	transform: translateY(1px);
}

.add svg, .subtract svg {
	flex-shrink: 0;
}

.add svg {
	width: 12px;
	height: 12px;
}

.add {
	color: white;
	background-color: #10303d;
}

.subtract {
	background-color: #cdcfd5;
}

.subtract svg {
	width: 12px;
	height: 2px;
}

input {
	text-align: center;
	border: 0;
	height: 36px;
	line-height: 1;
	font-size: 1.8rem;
	font-weight: 500;
	margin: 0 2px;
	transform: translateY(2px);
}
.hidden {
	display: none;
}
</style>
